import React from 'react'; //, { Component }
// import {withFirebase } from '../Firebase';
// import { AuthUserContext } from '../Session';
import FormBuilder from 'react-form-builder2';




const FilterQuestions = () => (
    <div>
    <FormBuilder.ReactFormBuilder />    
    </div>
);




export default FilterQuestions;